<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi" id="dedi"><a id="pV"></a>This book is for my family, <br/>especially my son, Ian, who wasn’t here for the first one, <br/>and my brothers and our parents, who were</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?ca1f4dbc